import React from 'react'

type Props = {
  title: React.ReactNode
  text: React.ReactNode
}

export const Introduction: React.FC<Props> = ({ title, text }) => (
  <>
    <div className="grid-outer-container grid-gap5-below">
      <div className="grid-row grid-gap2-below">
        <div className="grid-span12 grid-text-center">
          <h2 className="helper-nogap helper-nocase">{title}</h2>
        </div>
      </div>
      <div className="grid-row">
        <div className="grid-span8 grid-shift2 grid-tablet-span12 grid-tablet-shift0 grid-text-center">
          <span className="subheader">{text}</span>
        </div>
      </div>
    </div>
  </>
)
